//流动线材质
function LineFlowMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined;
    this._colorSubscription = undefined;
    this._time = new Date().getTime();

    this.color = options.color;
    this.speed = options.speed;
    this.repeat = options.repeat;
    this.axisY = options.axisY;
    this.image = options.image;
}

Object.defineProperties(LineFlowMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color')
});

LineFlowMaterialProperty.prototype.getType = function (time) {
    return Cesium.Material.LineFlowMaterialType;
};

LineFlowMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    result.color = Cesium.defaultValue(this.color,  Cesium.Color.WHITE);
    result.speed = Cesium.defaultValue(this.speed, 5);
    result.axisY = Cesium.defaultValue(this.axisY, false);
    result.image =  Cesium.defaultValue(this.image, Cesium.Material.DefaultImagePolylineTrailType);
    return result;
};

LineFlowMaterialProperty.prototype.equals = function (other) {
    return (
        this === other
    );
};
export default LineFlowMaterialProperty;